<template>
  <div class="game_strategy">
      <div v-if="type == 0" class="top">
          <div class="content">
            <i @click="goBack()"></i>
          </div>
      </div>

      <div class="header"></div>

      <div class="main_box">
        <div class="tab">
            <span :class="getTabClass(0)" @click="changeTab(0)">新手引导<i></i></span>
            <span :class="getTabClass(1)" @click="changeTab(1)">常见问题<i></i></span>      
        </div>
      </div>

      <div v-if="active == 0" class="new_guide">
        <img src="@/assets/images/strategy/new1.png" />
        <img src="@/assets/images/strategy/new2.png" />
        <img src="@/assets/images/strategy/new3.png" />
        <img src="@/assets/images/strategy/new4.png" />
        <img src="@/assets/images/strategy/new5.png" />
        <img src="@/assets/images/strategy/new6.png" />
        <div class="desc">
          <p><span>注意：</span>奖励一般分为【局数奖励】、【累赢奖励】、【等级奖励】。</p>
          <p><span>局数奖励：</span>按试玩范围内，参与一定局数的游戏即可拿到奖励；</p>
          <p><span>累赢奖励：</span>按试玩范围内，累计在游戏中赢取一定金额虚拟币即可拿到奖励；</p>
          <p><span>等级奖励：</span>按试玩范围内，游戏角色达到一定等级要求即可拿到奖励。</p>
        </div>
      </div>

      <div v-if="active == 1" class="question">

        <div class="block">
          <div class="title">
            <span></span>
            <p>游戏详情页面试玩信息不显示，怎么办？</p>
          </div>
          <div class="content">
            <div class="cont-main">
              <p>答：游戏绑定异常、试玩信息不显示/未注册，可能原因有：<p>
              <p><span>①</span>没有完成注册，请确认游戏是否已经微信登录；</p>
              <p><span>②</span>游戏数据延迟5-10分钟，请后台退出游戏后再返回刷新信息；</p>
              <p><span>③</span>同设备或者游戏号在其他渠道体验过，将无法在我们平台获得任务奖励。</p>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="title">
            <span></span>
            <p>如何打开游戏/应用设备号权限？</p>
          </div>
          <div class="content">
            <div class="cont-main">
              <p>答：<span>①</span>通用流程：设置--应用设置--权限管理，打开对应手机识别码或者IMEI权限；<p>
              <p><span>②</span>部分手机无法使用通用流程请自行百度符合自身机型的操作。</p>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="title">
            <span></span>
            <p>任务奖励无法领取，显示未达到任务要求？</p>
          </div>
          <div class="content">
            <div class="cont-main">
              <p>答：无法领取任务奖励的可能原因有：<p>
              <p><span>①</span>试玩信息未绑定成功；</p>
              <p><span>②</span>试玩信息已绑定，但是累计数据未达到任务要求；</p>
              <p><span>③</span>其他情况请联系客服核实。</p>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="title">
            <span></span>
            <p>冲顶奖励怎么领取？</p>
          </div>
          <div class="content">
            <div class="cont-main">
              <p>答：冲顶奖励任务页面点击领取后会出现VIP官方客服微信号，请保存并添加微信客服审核领取。</p>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="title">
            <span></span>
            <p>游戏无法登录、闪退，怎么办？</p>
          </div>
          <div class="content">
            <div class="cont-main">
              <p>答：切换网络或者卸载重装试试，有时候网络不稳定是会出现这个情况。游戏进不去，切换网络、卸载重装、清缓存、重启手机，应该能解决大部分问题。</p>
              <p>若还是不行，请提供您的机型截图联系游戏中的客服反馈。</p>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="title">
            <span></span>
            <p>什么是新用户专享？</p>
          </div>
          <div class="content">
            <div class="cont-main">
              <p>答：新用户专享是您第一次下载该游戏可体验，下载过之后每一期您都是属于老用户不能参与新用户专享的任务。</p>
            </div>
          </div>
        </div>

        <div class="block">
          <div class="title">
            <span></span>
            <p>如有其他问题，请<b @click="goKefu()">联系客服</b>。</p>
          </div>
        </div>

      </div>

  </div>
</template>

<style>
  body {
    background: #fff;
    font-family:PingFang-SC-Regular,Helvetica Neue,Helvetica,microsoft yahei,sans-serif;
  }
</style>

<style scoped>
  .top {
    display: block;
    /* width: 100%; */
    height: 0.22rem;
    color: #F5F7FA;
    position: absolute;
    z-index: 98;
    top: 0.33rem;
  }
  .top .content {
    display: flex;
    width: 3.43rem;
    padding: 0 .165rem;
    height: 0.22rem;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }
  .top .content i {
    float: left;
    width: 0.17rem;
    height: 0.17rem;
    border-left: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    transform: rotate(45deg);
    overflow: hidden;
  }

  .header {
    position: relative;
    display: block;
    width: 100%;
    height: 2.44rem;
    background: url('~@/assets/images/strategy/header_bg.png') no-repeat;
    background-size: 3.75rem 2.44rem;
    overflow: hidden;
  }
  
  .main_box {
    position: relative;
    display: block;
    width: 3.75rem;
    background: #FFF;
    overflow: hidden;
    border-radius: .16rem .16rem 0 0;
    margin: -.31rem auto 0 auto;
    box-shadow: 0 .02rem .04rem 0 rgba(0,0,0,0.03);
  }

  .main_box .tab {
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-around;
    padding-top: .12rem;
    height: .44rem;
    position: relative;
  }

  .main_box .tab span {
    display: flex;
    width: 50%;
    height: .3rem;
    justify-content: center;
    align-items: center;
    font-size: .16rem;
    color: #333;
    cursor: pointer;
  }

  .main_box span:first-child {
    border-right: .01rem solid #f0f0f0;
  }
  
  .main_box .show, .main_box .show2 {
    color: #FF7F4B !important;
    font-weight: 500;
  }

  .main_box .show i, .main_box .show2 i {
    position:absolute;
    display: block;
    width: .18rem;
    height: .04rem;
    background-color: #FF7F4B;
    border-radius: .02rem;
    bottom: 0; 
  }

  .main_box .show i {
    left: calc(25% - 0.09rem);
  }

  .main_box .show2 i{
    right: calc(25% - 0.09rem);
  }

  .new_guide {
    display: flex;
    flex-flow: column;
  }

  .new_guide img {
      width: 3.75rem;
  }
  .new_guide .desc {
    border-top: 1px solid #efefef; 
    width: 3.09rem;
    padding: .43rem .33rem .33rem .33rem;
  }
  .new_guide .desc p {
    font-size: .14rem;
    margin-bottom: .1rem;
    line-height: .20rem;
    color: #151515;
  }
  .new_guide .desc p span {
    color: #FF5E40;
  }

  .block {
    display: block;
    padding: 0 .44rem 0 .2rem;
    margin-top: .5rem;
  }

  .block:first-child{
    margin-top: .33rem;
  }

  .block:last-child{
    margin-bottom: .66rem;
  }

  .block .title {
    display: flex;
  }

  .block .title p {
    font-size: .16rem;
    color: #333;
    padding: 0;
    margin: 0 0 0 .06rem;
    line-height: .20rem;
    font-weight: 800;
  }

  .block .title span {
    display: flex;
    width: .24rem;
    height: .2rem;
    background: url('~@/assets/images/strategy/q.png') no-repeat;
    background-size: .2rem .2rem;
  }

  .block .content {
    margin-top: .16rem;
    margin-left: .08rem;
    padding-left: .16rem;
    border-left: .02rem solid #FFE9E4;
    font-size: .14rem;
    color: #333;
  }

  .block .content p {
    line-height: .20rem;
    margin-top: .06rem;
  }

  .block .content p span {
    font-size: .14rem;
  }

  .block:last-child .title span {
    display: flex;
    width: .24rem;
    height: .2rem;
    background: url('~@/assets/images/strategy/k.png') no-repeat;
    background-size: .2rem .2rem;
  }

  .block:last-child .title b{
    cursor: pointer;
    color: #FF5E40;
    text-decoration:underline
  }

</style>

<script>
export default {
  created() {
    document.title = "试玩攻略";
  },
  data() {
    return {
      type: this.$route.query.type == 1 ? 1 : 0,
      active: 0,
      kefu: '17007126925'
    }
  },
  methods: {
    getTabClass (i) {
      if (i == 0 && this.active == i){
        return 'show'
      } else if (i == 1 && this.active == i){
        return 'show2'
      }
      return ''
    },
    changeTab (i) {
      this.active = i
    },
    goBack: function () {
      window.injectedObject.setJsContent('closeWebview', '')
    },
    goKefu () {
      window.injectedObject.setJsContent('qqservice', this.kefu)
    }
  }
}
</script>